<template>
  <el-drawer
    :title="`业主来电：${indexThis.userPhoneNumber}`"
    :visible.sync="drawer"
    destroy-on-close
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'width210' : 'width54'"
  >
    <div class="drawer">
      <CardHouses />
      <el-tabs v-if="activeName !== '0'" v-model="activeName">
        <el-tab-pane label="新增工单" name="1" />
        <el-tab-pane label="住户信息" name="2" :disabled="disabledChange" />
        <el-tab-pane label="工单历史" name="3" :disabled="disabledChange" />
        <el-tab-pane label="缴费记录" name="4" :disabled="disabledChange" />
        <el-tab-pane label="缴费明细" name="5" :disabled="disabledChange" />
        <el-tab-pane label="房屋未缴" name="6" :disabled="disabledChange" />
        <!-- <el-tab-pane label="车位未缴" name="6" :disabled="disabledChange" /> -->
      </el-tabs>
      <CardWorkAdd v-if="activeName === '1'" ref="CardWorkAdd" />
      <CardHousesInfo v-if="activeName === '2'" ref="CardHousesInfo" />
      <CardWorkList v-else-if="activeName === '3'" ref="CardWorkList" />
      <CardPaymentList v-else-if="activeName === '4'" />
      <CardPaymentDetails v-else-if="activeName === '5'" />
      <CardPayOrderList v-else-if="activeName === '6'" />
      <!-- <CardParkSpaceUnPayOrderList v-else-if="activeName === '6'" /> -->
    </div>
  </el-drawer>
</template>

<script>
import CardHouses from './CardHouses'
import CardWorkAdd from './CardWorkAdd'
import CardHousesInfo from './CardHousesInfo'
import CardWorkList from './CardWorkList'
import CardPaymentList from './CardPaymentList'
import CardPayOrderList from './CardPayOrderList'
import CardPaymentDetails from './CardPaymentDetails'
import CardParkSpaceUnPayOrderList from './CardParkSpaceUnPayOrderList'

export default {
  components: {
    CardHouses,
    CardWorkAdd,
    CardHousesInfo,
    CardWorkList,
    CardPaymentList,
    CardPayOrderList,
    CardPaymentDetails,
    CardParkSpaceUnPayOrderList,
  },
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      activeName: '1',
    }
  },
  watch: {
    drawer(val) {
      if (!val) this.indexThis.state = 1
    },
  },
  computed: {
    disabledChange() {
      return this.indexThis.housesList.length === 0
    },
  },
}
</script>

<style scoped lang="scss">
.drawer {
  margin: 10px 24px;
}

::v-deep .el-drawer__header {
  color: #0faf39 !important;
}
</style>
